import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import UIActions from '../ui/UIActions';
import SidebarRow, { SidebarRowRightContent } from './SidebarRow';
import styles from './SidebarSection.module.scss';
import SidebarSectionAnimation from './SidebarSectionAnimation';

interface SidebarSectionProps {
  children?: React.ReactNode;
  id: string;
  title: string;
  icon?: React.ReactNode;
  menuItems?: React.ReactNode;
  customMenu?: React.ReactNode;
  hidden?: boolean;
  initiallyCollapsed?: boolean;
  empty?: boolean;
}

const SidebarSection = ({
  children,
  id,
  title,
  menuItems,
  icon,
  customMenu,
  hidden,
  initiallyCollapsed,
  empty,
}: SidebarSectionProps) => {
  const dispatch = useAppDispatch();
  const collapsedSidebarSections = useAppSelector(
    (state) => state.ui.collapsedSidebarSections,
  );

  const isExpanded =
    id in collapsedSidebarSections
      ? !collapsedSidebarSections[id]
      : !initiallyCollapsed;

  const handleExpandClick: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(UIActions.toggleSidebarSection(id, !!initiallyCollapsed));
  };

  return (
    <div
      className={classNames(styles.container, {
        [styles.expanded]: !empty && isExpanded,
        [styles.hidden]: hidden,
      })}
      aria-label={_.startCase(title)}
    >
      <div>
        <SidebarRow
          icon={icon}
          onClick={handleExpandClick}
          rightContent={
            <SidebarRowRightContent
              expanded={isExpanded}
              onExpandClick={handleExpandClick}
              menuItems={menuItems}
              customMenu={customMenu}
            />
          }
        >
          {title}
        </SidebarRow>
      </div>
      <SidebarSectionAnimation sectionKey={id} expanded={isExpanded}>
        {children}
      </SidebarSectionAnimation>
    </div>
  );
};

export default SidebarSection;
